/**
 * 分拣批次页面的可变 mock 状态（页面级 useReducer 持有，页面卸载 / 切换仓库即重置）。
 * todo batch mock: 后端接入后由接口数据 + refetch 替代，删除本文件。
 */
import { BagMove, BatchBag, BatchLog, ParcelMoveIn, SortingBatch } from '../types';
import { buildInboundSeed, buildOutboundSeed, getMockSortCodes, MOCK_NEXT_BATCH_ID } from './batchMock';

export interface SortingBatchMockState {
    hubPrefix: string;
    /** 种子数据的「现在」 */
    seededAt: number;
    sortCodes: string[];
    outbound: SortingBatch[];
    inbound: SortingBatch[];
    nextBatchId: number;
    /** 本次会话产生的操作日志（新建同步结束、移入、移出） */
    sessionLogs: BatchLog[];
    /** 本次会话新建的包牌（创建包牌 / 移入时新建），按批次 id */
    extraBags: Record<number, BatchBag[]>;
    /** 整包移入的包牌，按目标批次 id */
    movedInBags: Record<number, BatchBag[]>;
    /** 已离开某批次的包牌，key = `${batchNumber}|${bagNumber}` */
    movedOutBags: Record<string, true>;
    /** 已移出、不属于任何批次的号码 */
    removedNumbers: Record<string, true>;
    /** 包牌在批次间的移动记录，按包牌号 */
    bagMoves: Record<string, BagMove[]>;
    /** 包裹移入记录，按目标包牌号 */
    parcelMoveIns: Record<string, ParcelMoveIn[]>;
    /** 最近手动更新时间 */
    refreshedAt: number;
}

export const floorToMinute = (time: number): number => Math.floor(time / 60000) * 60000;

export const createInitialMockState = (hubPrefix: string, now: number): SortingBatchMockState => {
    const seededAt = floorToMinute(now);
    return {
        hubPrefix,
        seededAt,
        sortCodes: getMockSortCodes(hubPrefix),
        outbound: buildOutboundSeed(hubPrefix, seededAt),
        inbound: buildInboundSeed(hubPrefix, seededAt),
        nextBatchId: MOCK_NEXT_BATCH_ID,
        sessionLogs: [],
        extraBags: {},
        movedInBags: {},
        movedOutBags: {},
        removedNumbers: {},
        bagMoves: {},
        parcelMoveIns: {},
        refreshedAt: seededAt,
    };
};

export const movedOutKey = (batchNumber: string, bagNumber: string): string => `${batchNumber}|${bagNumber}`;
